import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { login as loginApi } from "services/apiAuth";

export function useLogin() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const { mutate: login, isLoading } = useMutation({
    mutationFn: ({ phonenumber, password }) =>
      loginApi({ phonenumber, password }),
    onSuccess: (data) => {
      queryClient.setQueryData(["user"], data);
      navigate("/dashboard", { replace: true });
      window.location.reload();
    },
    onError: (err) => {
      console.error("ERROR", err);
      toast.error("Provided phone number or password are incorrect");
    },
  });

  return { login, isLoading };
}
